<template>
  <vs-wrapper space="small">
    <v-row v-for="row in detailRows" data-test="detail-row">
      <v-col cols="3" class="d-flex" data-test="detail-row-title">
        <vs-text type="alt-paragraph">{{ row.title }}</vs-text>
      </v-col>
      <v-col data-test="detail-row-value">
        <vs-text>{{ row.value }}</vs-text>
      </v-col>
    </v-row>
    <div v-if="isRepeatRequest">
      <v-row>
        <v-col cols="3">
          <vs-text type="alt-paragraph">Route</vs-text>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <job-card-locations-detail
            class="ml-3"
            :inventory="inventory"
            :destination-location-name="job.destination_name"
          />
        </v-col>
      </v-row>
    </div>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import VsText from '@/components/vision/VsText.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import JobCardLocationsDetail from '@/components/jobs/JobCardLocationsDetail.vue'
import { JobRequestJobsResponse } from '@/models/types/job-request-jobs-response'
import { JobStopType } from '@ironsight/types'
import { useGetJobRequestedStopsQuery } from '@/api/jobs'

const props = defineProps<{
  job: JobRequestJobsResponse
  isRepeatRequest?: boolean
}>()

const store = useStore()
const getUserBySid = computed(() => store.getters['users/getBySid'])
const jobCreatorName = computed(
  () => getUserBySid.value(props.job.created_by_user_sid)?.name ?? 'Unknown User',
)
const jobRequesterName = computed(
  () => getUserBySid.value(props.job.requester_user_sid)?.name ?? 'Unknown User',
)
const detailRows = computed(() => {
  return [
    { title: 'Creator', value: jobCreatorName.value },
    { title: 'Requestor', value: jobRequesterName.value },
    ...(props.job.details ? [{ title: 'Details', value: props.job.details }] : []),
  ]
})

const { data: requestedStops } = useGetJobRequestedStopsQuery(props.job.id)
const inventory = computed(() =>
  (requestedStops.value ?? [])
    .filter((stop) => stop.stopType === JobStopType.PickUp)
    .map((stop) => {
      return stop.inventory.map((inv) => ({
        name: inv.inventoryTypeName,
        inventoryTypeId: inv.inventoryTypeId,
        inventorySubTypeName: inv.inventorySubTypeName,
        inventorySubTypeId: inv.inventorySubTypeId,
        quantity: inv.quantity,
        pickupLocationId: stop.locationId,
        pickupLocationName: stop.locationName,
        inventoryId: 0, // Not used
        position: stop.position,
        assetConditions: [], // Not used
      }))
    })
    .flatMap((x) => x),
)
</script>

<style scoped></style>
